<div class="d-grid footer-grid container">
	<div class="fw-bolder">
		{{ 'footer.ade' | translate }}
	</div>
	<div class="fw-bolder">
		{{ 'footer.ade' | translate }}
	</div>
	<div class="fw-bolder">
		{{ 'footer.service' | translate }}
	</div>
	<address>
		<div>{{ 'footer.brand' | translate }}</div>
		<div class="linebreak-after-backslash-n">{{ 'footer.address' | translate }}</div>
	</address>
	<div>
		@for (keypart of infoLinkKeyParts; track keypart) {
			<div>
				<a
					[ngClass]="darkTheme ? 'text-white' : 'text-dark'"
					[href]="'footer.' + keypart + '.link' | translate"
					rel="noreferrer"
					target="_blank"
					>{{ 'footer.' + keypart + '.title' | translate }}</a
				>
			</div>
		}
	</div>
	<div>
		@for (keypart of serviceLinkKeyParts; track keypart) {
			<div>
				<a
					[ngClass]="darkTheme ? 'text-white' : 'text-dark'"
					[href]="'footer.' + keypart + '.link' | translate"
					rel="noreferrer"
					target="_blank"
					>{{ 'footer.' + keypart + '.title' | translate }}</a
				>
			</div>
		}
	</div>
</div>
